
define('text!modules/home/main/templates/history.item.template.html',[],function () { return '<div class="homeActivityIconHolder">\r\n    <span class="homeActivityIcon ">\r\n    </span>\r\n</div>\r\n<div class="homeActivityText">\r\n    <a class="homeActivityLine1 clickable"></a>\r\n    <div class="homeActivityLine2"></div>\r\n    <div class="homeActivityLine3"></div>\r\n</div>';});

